/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == (typeof o === "undefined" ? "undefined" : _typeof(o))) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(4)) === 'object' && __webpack_require__(4)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getId;
/* harmony export (immutable) */ __webpack_exports__["e"] = clamp;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrEquals;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrAdd;
/* harmony export (immutable) */ __webpack_exports__["c"] = arrScale;
/* harmony export (immutable) */ __webpack_exports__["d"] = arrSubtract;
var id = 0;

function getId() {
    return (id++).toString();
}

function clamp(min, max, x) {
    return Math.max(min, Math.min(max, x));
}

function arrEquals(a, b) {
    return a.length === b.length && a.every(function (x, i) {
        return x === b[i];
    });
}

function arrAdd(a, b) {
    return a.map(function (x, i) {
        return x + b[i];
    });
}

function arrScale(m, a) {
    return a.map(function (x) {
        return m * x;
    });
}

function arrSubtract(a, b) {
    return a.map(function (x, i) {
        return x - b[i];
    });
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Node; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Edge; });
/* unused harmony export Component */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Diagram; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDirection(_ref, _ref2) {
    var _ref4 = _slicedToArray(_ref, 2),
        x1 = _ref4[0],
        y1 = _ref4[1];

    var _ref3 = _slicedToArray(_ref2, 2),
        x2 = _ref3[0],
        y2 = _ref3[1];

    var dx = x2 - x1,
        dy = y2 - y1;

    var signs = [dx, dy].map(Math.sign);
    var directions = [['l', '', 'r'], ['u', '', 'd']];

    return [dx, dy].map(function (d, i) {
        return directions[i][signs[i] + 1].repeat(Math.abs(d));
    }).join('');
}

function renderEdge(vnode) {
    var co = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (vnode.attributes.direction == null) return '';

    var needWrapChars = ['"', ',', ']'];
    var labelPosition = vnode.attributes.labelPosition || 'left';

    if (co === !vnode.attributes.alt && labelPosition !== 'inside') labelPosition = labelPosition === 'left' ? 'right' : 'left';

    var p = { left: '^', right: "_", inside: '|-' }[labelPosition];

    var _ref5 = vnode.attributes.value != null && needWrapChars.some(function (c) {
        return vnode.attributes.value.includes(c);
    }) ? ['{', '}'] : ['', ''],
        _ref6 = _slicedToArray(_ref5, 2),
        w1 = _ref6[0],
        w2 = _ref6[1];

    var valueArg = vnode.attributes.value != null ? p + '{' + w1 + vnode.attributes.value + w2 + '}' : '';
    //   let args = ['', valueArg, ...(vnode.attributes.args || [])].filter(x => x != null).join(', ')
    /*
    let xydict = ({
                            "harpoon": '^>',
                            "harpoon'": '_>',
                            "hook": '^{(}',
                            "hook'": '_{(}',
                            "maps to": '|',
                            "tail": ')',
                            "two heads": '>>',
                            "dashed": '--',
                            "dotted": '.',
                            "solid": '-'
                        })
                        */
    var args = vnode.attributes.args != null ? vnode.attributes.args.join('') : '';
    args = args != '' ? '@{' + vnode.attributes.args.join('') + '}' : '';
    return '\\ar' + vnode.attributes.xybend + args + '[' + vnode.attributes.direction + ']' + valueArg;
}

var Node = function Node() {};
var Edge = function Edge() {};

var Component = function () {
    function Component(props) {
        _classCallCheck(this, Component);

        this.props = props;
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {}
    }]);

    return Component;
}();

var Diagram = function (_Component) {
    _inherits(Diagram, _Component);

    function Diagram(props) {
        _classCallCheck(this, Diagram);

        var _this = _possibleConstructorReturn(this, (Diagram.__proto__ || Object.getPrototypeOf(Diagram)).call(this, props));

        var getChildren = function getChildren(vnode) {
            return vnode.children.reduce(function (acc, v) {
                if (v == null) return acc;

                if ([Node, Edge].includes(v.nodeName)) {
                    acc.push(v);
                } else {
                    acc.push.apply(acc, _toConsumableArray(getChildren(v)));
                }

                return acc;
            }, []);
        };

        var children = getChildren(_this.props);

        _this.nodes = children.reduce(function (acc, v) {
            if (v.nodeName !== Node || !v.key || !v.attributes.position) return acc;

            if (!(v.key in acc)) acc[v.key] = v;else acc[v.key] = _extends({}, acc[v.key], {
                attributes: _extends({}, acc[v.key].attributes, v.attributes)
            });

            return acc;
        }, {});

        _this.edges = children.reduce(function (acc, v) {
            if (v.nodeName !== Edge || !v.attributes.from || !v.attributes.to) return acc;

            var _ref7 = !props.co ? ['from', 'to'] : ['to', 'from'],
                _ref8 = _slicedToArray(_ref7, 2),
                from = _ref8[0],
                to = _ref8[1];

            if (!(v.attributes[from] in acc)) acc[v.attributes[from]] = [];

            acc[v.attributes[from]].push(_extends({}, v, {
                attributes: _extends({}, v.attributes, {
                    direction: getDirection(_this.nodes[v.attributes[from]].attributes.position, _this.nodes[v.attributes[to]].attributes.position)
                })
            }));

            return acc;
        }, {});
        return _this;
    }

    _createClass(Diagram, [{
        key: 'getBounds',
        value: function getBounds() {
            var _this2 = this;

            return Object.keys(this.nodes).map(function (key) {
                return _this2.nodes[key].attributes.position;
            }).reduce(function (_ref9, _ref10) {
                var _ref12 = _slicedToArray(_ref9, 4),
                    minX = _ref12[0],
                    maxX = _ref12[1],
                    minY = _ref12[2],
                    maxY = _ref12[3];

                var _ref11 = _slicedToArray(_ref10, 2),
                    x = _ref11[0],
                    y = _ref11[1];

                return [Math.min(minX, x), Math.max(maxX, x), Math.min(minY, y), Math.max(maxY, y)];
            }, [Infinity, -Infinity, Infinity, -Infinity]);
        }
    }, {
        key: 'toArray',
        value: function toArray() {
            var _getBounds = this.getBounds(),
                _getBounds2 = _slicedToArray(_getBounds, 4),
                minX = _getBounds2[0],
                maxX = _getBounds2[1],
                minY = _getBounds2[2],
                maxY = _getBounds2[3];

            if (minX > maxX || minY > maxY) return [];

            var diagram = Array(maxY - minY + 1).fill().map(function (_) {
                return Array(maxX - minX + 1).fill(null);
            });

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(this.nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    var _nodes$key$attributes = _slicedToArray(this.nodes[key].attributes.position, 2),
                        x = _nodes$key$attributes[0],
                        y = _nodes$key$attributes[1];

                    diagram[y - minY][x - minX] = {
                        node: this.nodes[key],
                        edges: this.edges[key] || []
                    };
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return diagram;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var options = this.props.options == null ? '' : '[' + this.props.options + ']';

            return ['\\xymatrix{', this.toArray().map(function (entries) {
                return entries.map(function (entry) {
                    return entry == null ? '' : [entry.node.attributes.value || '{}'].concat(_toConsumableArray(entry.edges.map(function (e) {
                        return renderEdge(e, _this3.props.co);
                    }))).join(' ');
                }).join(' & ');
            }).join(' \\\\\n'), '}'].join('\n');
        }
    }]);

    return Diagram;
}(Component);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Separator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Button = function (_Component) {
    _inherits(Button, _Component);

    function Button() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Button);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (evt) {
            evt.preventDefault();

            var _this$props$onClick = _this.props.onClick,
                onClick = _this$props$onClick === undefined ? function () {} : _this$props$onClick;

            onClick(evt);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Button, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                checked = _props.checked,
                disabled = _props.disabled,
                icon = _props.icon,
                name = _props.name;


            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                {
                    'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('button', this.props.class, { checked: checked, disabled: disabled }),
                    title: name
                },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'a',
                    { href: '#', onClick: this.handleClick },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
                        style: { backgroundImage: 'url(\'' + icon + '\')' },
                        src: './img/tools/blank.svg',
                        alt: name
                    })
                )
            );
        }
    }]);

    return Button;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Separator = function Separator() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'li',
        { 'class': 'separator' },
        'Separator'
    );
};

var Toolbox = function (_Component2) {
    _inherits(Toolbox, _Component2);

    function Toolbox() {
        _classCallCheck(this, Toolbox);

        return _possibleConstructorReturn(this, (Toolbox.__proto__ || Object.getPrototypeOf(Toolbox)).apply(this, arguments));
    }

    _createClass(Toolbox, [{
        key: 'render',
        value: function render() {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'section',
                { 'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('toolbox', this.props.class), id: this.props.id },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'ul',
                    null,
                    this.props.children
                )
            );
        }
    }]);

    return Toolbox;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["c"] = (Toolbox);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App__ = __webpack_require__(7);



// Configure MathJax

MathJax.Hub.processSectionDelay = 0;
MathJax.Hub.processUpdateDelay = 0;

MathJax.Hub.Config({
    messageStyle: 'none',
    skipStartupTypeset: true,
    showMathMenu: false,
    errorSettings: { message: [''] }
});

// Render

Object(__WEBPACK_IMPORTED_MODULE_0_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__components_App__["a" /* default */], null), document.body);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_copy_text_to_clipboard__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_copy_text_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_copy_text_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__diagram__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Grid__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Properties__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Toolbox__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var App = function (_Component) {
    _inherits(App, _Component);

    function App() {
        _classCallCheck(this, App);

        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));

        _this.copyCode = function () {
            if (_this.state.confirmCodeCopy) return;

            var code = __WEBPACK_IMPORTED_MODULE_2__diagram__["c" /* toTeX */](_this.state.diagram);
            var success = __WEBPACK_IMPORTED_MODULE_1_copy_text_to_clipboard___default()(code);

            if (success) {
                _this.setState({ confirmCodeCopy: true });
                setTimeout(function () {
                    return _this.setState({ confirmCodeCopy: false });
                }, 1000);
            } else {
                prompt('Copy code down below:', code.replace(/\n/g, ' '));
            }
        };

        _this.copyLink = function () {
            if (_this.state.confirmLinkCopy) return;

            var encoded = __WEBPACK_IMPORTED_MODULE_2__diagram__["b" /* toBase64 */](_this.state.diagram);
            var base = window.location.href.split('#')[0];

            var url = base + '#' + encoded;
            window.history.replaceState(null, null, '#' + encoded);

            var success = __WEBPACK_IMPORTED_MODULE_1_copy_text_to_clipboard___default()(url);

            if (success) {
                _this.setState({ confirmLinkCopy: true });
                setTimeout(function () {
                    return _this.setState({ confirmLinkCopy: false });
                }, 1000);
            } else {
                prompt('Copy link down below:', url);
            }
        };

        _this.moveInHistory = function (step) {
            if (_this.history[_this.historyPointer + step] == null) return;

            _this.historyPointer += step;

            _this.setState({
                diagram: _this.history[_this.historyPointer].diagram,
                selectedEdge: null
            });
        };

        _this.undo = function () {
            return _this.moveInHistory(-1);
        };

        _this.redo = function () {
            return _this.moveInHistory(1);
        };

        _this.handleDataChange = function (evt) {
            var edgeAdded = _this.state.diagram.edges.length + 1 === evt.data.edges.length;
            var historyEntry = { diagram: evt.data, time: Date.now() };

            if ((_this.historyPointer < _this.history.length - 1 || Date.now() - _this.history[_this.historyPointer].time > 500) && _this.history[_this.historyPointer].diagram !== evt.data) {
                _this.history.splice(_this.historyPointer + 1, _this.history.length, historyEntry);
                _this.historyPointer = _this.history.length - 1;
            } else {
                _this.history[_this.historyPointer] = historyEntry;
            }

            _this.setState({
                diagram: evt.data,
                selectedEdge: edgeAdded ? evt.data.edges.length - 1 : _this.state.selectedEdge
            });
        };

        _this.handleEdgeClick = function (evt) {
            _this.setState({ selectedEdge: _this.state.selectedEdge === evt.edge ? null : evt.edge });
        };

        _this.handleToolClick = function (tool) {
            if (_this.toolClickHandlersCache == null) _this.toolClickHandlersCache = {};

            if (_this.toolClickHandlersCache[tool] == null) {
                _this.toolClickHandlersCache[tool] = function (evt) {
                    _this.setState({ tool: tool, selectedEdge: null });
                };
            }

            return _this.toolClickHandlersCache[tool];
        };

        _this.handleAboutClick = function () {
            var a = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', { href: 'https://github.com/darknmt/xypic-editor', target: '_blank' }), document.body);

            a.click();
            a.remove();
        };

        _this.handleEdgeChange = function (evt) {
            var newEdges = [].concat(_toConsumableArray(_this.state.diagram.edges));

            newEdges[_this.state.selectedEdge] = _extends({}, newEdges[_this.state.selectedEdge], evt.data);

            if (evt.data.value != null && evt.data.value.trim() === '') {
                delete newEdges[_this.state.selectedEdge].value;
            }

            _this.handleDataChange({
                data: {
                    nodes: _this.state.diagram.nodes,
                    edges: newEdges
                }
            });
        };

        _this.handleEdgeRemoveClick = function () {
            var newEdges = _this.state.diagram.edges.filter(function (_, i) {
                return i !== _this.state.selectedEdge;
            });

            var newNodes = _this.state.diagram.nodes.filter(function (n) {
                return n.value.trim() !== '' || newEdges.some(function (e) {
                    return e.from === n.id || e.to === n.id;
                });
            });

            _this.handleDataChange({
                data: {
                    nodes: newNodes,
                    edges: newEdges
                }
            });

            _this.setState({ selectedEdge: null });
        };

        _this.state = {
            tool: 'pan',
            cellSize: 130,
            selectedEdge: null,
            confirmCodeCopy: false,
            confirmLinkCopy: false,
            diagram: { nodes: [], edges: [] }

            // Try to load a diagram from the hash if given

        };if (window.location.hash.length > 0) {
            try {
                _this.state.diagram = __WEBPACK_IMPORTED_MODULE_2__diagram__["a" /* fromBase64 */](window.location.hash.slice(1));
            } catch (err) {
                alert('Invalid URL encoding');
            }
        }

        _this.history = [{ diagram: _this.state.diagram, time: Date.now() }];
        _this.historyPointer = 0;
        return _this;
    }

    _createClass(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            // Switch tool when holding Control and Space

            var toolControl = {
                17: 'arrow', // Control
                32: 'pan' // Space
            };

            document.addEventListener('keydown', function (evt) {
                if (toolControl[evt.keyCode] != null) {
                    if (_this2.prevTool != null) return;

                    _this2.prevTool = _this2.state.tool;
                    _this2.setState({ tool: toolControl[evt.keyCode] });
                }
            });

            document.addEventListener('keyup', function (evt) {
                if (Object.keys(toolControl).includes(evt.keyCode.toString())) {
                    // Space or Control

                    if (_this2.prevTool == null) return;

                    _this2.setState({ tool: _this2.prevTool });
                    _this2.prevTool = null;
                }
            });

            document.addEventListener('keyup', function (evt) {
                if (evt.keyCode === 27) {
                    // Escape

                    _this2.setState({ selectedEdge: null });
                }
            });

            window.addEventListener('beforeunload', function (evt) {
                var message = 'Do you really want to leave?';

                evt.returnValue = message;
                return message;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { id: 'root' },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Grid__["a" /* default */], {
                    cellSize: this.state.cellSize,
                    data: this.state.diagram,
                    mode: this.state.tool,
                    selectedEdge: this.state.selectedEdge,

                    onDataChange: this.handleDataChange,
                    onEdgeClick: this.handleEdgeClick
                }),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__Properties__["a" /* default */], {
                    edgeId: this.state.selectedEdge,
                    show: this.state.selectedEdge != null,
                    data: this.state.diagram.edges[this.state.selectedEdge],

                    onChange: this.handleEdgeChange,
                    onRemoveClick: this.handleEdgeRemoveClick
                }),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_5__Toolbox__["c" /* default */],
                    { id: 'toolbox' },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Toolbox__["a" /* Button */], {
                        checked: this.state.tool === 'pan',
                        icon: './img/tools/pan.svg',
                        name: 'Pan Tool (Space)',
                        onClick: this.handleToolClick('pan')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Toolbox__["a" /* Button */], {
                        checked: this.state.tool === 'arrow',
                        icon: './img/tools/arrow.svg',
                        name: 'Arrow Tool (Ctrl)',
                        onClick: this.handleToolClick('arrow')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Toolbox__["b" /* Separator */], null),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Toolbox__["a" /* Button */], {
                        disabled: this.history[this.historyPointer - 1] == null,
                        icon: './img/tools/undo.svg',
                        name: 'Undo',
                        onClick: this.undo
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Toolbox__["a" /* Button */], {
                        disabled: this.history[this.historyPointer + 1] == null,
                        icon: './img/tools/redo.svg',
                        name: 'Redo',
                        onClick: this.redo
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Toolbox__["b" /* Separator */], null),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Toolbox__["a" /* Button */], {
                        icon: './img/tools/' + (this.state.confirmCodeCopy ? 'tick' : 'code') + '.svg',
                        name: 'Copy Diagram Code',
                        onClick: this.copyCode
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Toolbox__["a" /* Button */], {
                        icon: './img/tools/' + (this.state.confirmLinkCopy ? 'tick' : 'link') + '.svg',
                        name: 'Copy Diagram Permalink',
                        onClick: this.copyLink
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Toolbox__["b" /* Separator */], null),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__Toolbox__["a" /* Button */], {
                        icon: './img/tools/about.svg',
                        name: 'GitHub Repository',
                        onClick: this.handleAboutClick
                    })
                )
            );
        }
    }]);

    return App;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (input) {
	var el = document.createElement('textarea');

	el.value = input;

	// Prevent keyboard from showing on mobile
	el.setAttribute('readonly', '');

	el.style.contain = 'strict';
	el.style.position = 'absolute';
	el.style.left = '-9999px';
	el.style.fontSize = '12pt'; // Prevent zooming on iOS

	var selection = getSelection();
	var originalRange = false;
	if (selection.rangeCount > 0) {
		originalRange = selection.getRangeAt(0);
	}

	document.body.appendChild(el);
	el.select();

	// Explicit selection workaround for iOS
	el.selectionStart = 0;
	el.selectionEnd = input.length;

	var success = false;
	try {
		success = document.execCommand('copy');
	} catch (err) {}

	document.body.removeChild(el);

	if (originalRange) {
		selection.removeAllRanges();
		selection.addRange(originalRange);
	}

	return success;
};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toJSON */
/* unused harmony export fromJSON */
/* harmony export (immutable) */ __webpack_exports__["b"] = toBase64;
/* harmony export (immutable) */ __webpack_exports__["a"] = fromBase64;
/* harmony export (immutable) */ __webpack_exports__["c"] = toTeX;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsx_tikzcd__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




function toJSON(diagram) {
    var leftTop = [0, 1].map(function (i) {
        return diagram.nodes.reduce(function (min, node) {
            return Math.min(min, node.position[i]);
        }, Infinity);
    });

    return JSON.stringify({
        nodes: diagram.nodes.map(function (node) {
            return _extends({}, node, {
                id: undefined,
                position: node.position.map(function (x, i) {
                    return x - leftTop[i];
                })
            });
        }),

        edges: diagram.edges.map(function (edge) {
            return _extends({}, edge, {
                from: diagram.nodes.findIndex(function (node) {
                    return node.id === edge.from;
                }),
                to: diagram.nodes.findIndex(function (node) {
                    return node.id === edge.to;
                })
            });
        })
    });
}

function fromJSON(json) {
    var obj = JSON.parse(json);
    var nodes = obj.nodes.map(function (node) {
        return _extends({}, node, {
            id: __WEBPACK_IMPORTED_MODULE_1__helper__["f" /* getId */]()
        });
    });

    return {
        nodes: nodes,
        edges: obj.edges.map(function (edge) {
            return _extends({}, edge, {
                from: nodes[edge.from].id,
                to: nodes[edge.to].id
            });
        })
    };
}

function toBase64(diagram) {
    return btoa(toJSON(diagram));
}

function fromBase64(base64) {
    return fromJSON(atob(base64));
}

function toTeX(diagram) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_jsx_tikzcd__["e" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_0_jsx_tikzcd__["d" /* h */])(
        __WEBPACK_IMPORTED_MODULE_0_jsx_tikzcd__["a" /* Diagram */],
        null,
        diagram.nodes.map(function (node, i) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_jsx_tikzcd__["d" /* h */])(__WEBPACK_IMPORTED_MODULE_0_jsx_tikzcd__["c" /* Node */], {
                key: node.id,
                position: node.position,
                value: node.value
            });
        }),
        diagram.edges.map(function (edge) {
            return [Object(__WEBPACK_IMPORTED_MODULE_0_jsx_tikzcd__["d" /* h */])(__WEBPACK_IMPORTED_MODULE_0_jsx_tikzcd__["b" /* Edge */], {
                from: edge.from,
                to: edge.to,
                value: edge.value,
                labelPosition: edge.labelPosition,
                args: [].concat(_toConsumableArray([edge.tail, edge.line, edge.head].map(function (id, i) {
                    return {
                        none: ['', '-', ''][i],
                        default: ['', '-', '>'][i],
                        null: ['', '-', '>'][i],
                        undefined: ['', '-', '>'][i],
                        harpoon: '^>',
                        harpoonalt: "_>'",
                        hook: '^{(}',
                        hookalt: "_{(}",
                        mapsto: '|',
                        tail: ')',
                        twoheads: '>>',
                        dashed: '--',
                        dotted: '.',
                        solid: '-',
                        double: '='
                    }[id];
                }))).filter(function (x) {
                    return x != null;
                }),
                xybend: edge.bend > 0 ? '@/^' + { 30: '', 49: '1pc', 60: '1.5pc', 67: '2pc', 71: '2.5pc', 74: '3pc', 76: '3.5pc', 78: '4pc', 79: '4.5pc', 80: '5pc' }[edge.bend] + '/' : edge.bend < 0 ? '@/_' + { 30: '', 49: '1pc', 60: '1.5pc', 67: '2pc', 71: '2.5pc', 74: '3pc', 76: '3.5pc', 78: '4pc', 79: '4.5pc', 80: '5pc' }[-edge.bend] + '/' : ''

            })];
        })
    ));
}

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__h__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__render__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__h__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__render__["a"]; });
/* unused harmony reexport corender */
/* unused harmony reexport renderToDiagram */
/* unused harmony reexport Component */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__components__["b"]; });






/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = h;
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function h(nodeName, attributes) {
    for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        children[_key - 2] = arguments[_key];
    }

    var getChildren = function getChildren(children) {
        return children.reduce(function (acc, child) {
            if (child instanceof Array) {
                acc.push.apply(acc, _toConsumableArray(getChildren(child)));
            } else {
                acc.push(child);
            }

            return acc;
        }, []);
    };

    return {
        nodeName: nodeName,
        attributes: attributes || {},
        key: attributes && attributes.key,
        children: getChildren(children)
    };
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export renderToDiagram */
/* harmony export (immutable) */ __webpack_exports__["a"] = render;
/* unused harmony export corender */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function resolveComponents(vnode) {
    if (vnode == null) return null;

    if (![__WEBPACK_IMPORTED_MODULE_0__components__["a" /* Diagram */], __WEBPACK_IMPORTED_MODULE_0__components__["c" /* Node */], __WEBPACK_IMPORTED_MODULE_0__components__["b" /* Edge */]].includes(vnode.nodeName)) {
        var props = _extends({}, vnode.attributes, { children: vnode.children });

        if ('render' in vnode.nodeName.prototype) {
            return resolveComponents(new vnode.nodeName(props).render());
        } else {
            return resolveComponents(vnode.nodeName(props));
        }
    }

    return _extends({}, vnode, {
        children: vnode.children.map(function (x) {
            return resolveComponents(x);
        })
    });
}

function renderToDiagram(vnode) {
    var co = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var diagramNode = resolveComponents(vnode);

    if (diagramNode == null || diagramNode.nodeName !== __WEBPACK_IMPORTED_MODULE_0__components__["a" /* Diagram */]) return null;

    return new __WEBPACK_IMPORTED_MODULE_0__components__["a" /* Diagram */](_extends({}, diagramNode.attributes, {
        co: co !== !!diagramNode.attributes.co,
        children: diagramNode.children
    }));
}

function render(vnode) {
    var co = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return renderToDiagram(vnode, co).render();
}

function corender(vnode) {
    return render(vnode, true);
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GridCell__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GridEdge__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Grid = function (_Component) {
    _inherits(Grid, _Component);

    function Grid(props) {
        _classCallCheck(this, Grid);

        var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this));

        _this.handleNodeMouseDown = function (evt) {
            if (evt.button !== 0) return;

            var cellSize = _this.props.cellSize;
            var cameraPosition = _this.state.cameraPosition;

            var position = [evt.clientX, evt.clientY].map(function (x, i) {
                return Math.floor((x + cameraPosition[i]) / cellSize);
            });
            var nodeIndex = _this.props.data.nodes.findIndex(function (n) {
                return __WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](n.position, position);
            });
            var node = _this.props.data.nodes[nodeIndex];

            _this.mouseDown = {
                evt: evt, position: position, nodeIndex: nodeIndex, node: node,
                mode: _this.props.mode
            };
        };

        _this.handleNodeGrabberMouseDown = function (evt) {
            if (evt.button !== 0) return;

            evt.stopPropagation();

            var position = evt.position;

            var nodeIndex = _this.props.data.nodes.findIndex(function (n) {
                return __WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](n.position, position);
            });
            var node = _this.props.data.nodes[nodeIndex];

            _this.mouseDown = {
                evt: evt, position: position, nodeIndex: nodeIndex, node: node,
                mode: 'move'
            };
        };

        _this.handleNodeMouseUp = function (evt) {
            if (_this.mouseDown == null) return;

            var oldEvt = _this.mouseDown.evt;
            if (evt.clientX !== oldEvt.clientX || evt.clientY !== oldEvt.clientY) return;

            var position = _this.mouseDown.position;


            _this.setState({
                editPosition: position
            });
        };

        _this.handleNodeSubmit = function () {
            _this.setState({ editPosition: [null, null] });
        };

        _this.handleNodeChange = function (evt) {
            var _this$props$onDataCha = _this.props.onDataChange,
                onDataChange = _this$props$onDataCha === undefined ? function () {} : _this$props$onDataCha;


            var nodes = [].concat(_toConsumableArray(_this.props.data.nodes));
            var index = nodes.findIndex(function (n) {
                return __WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](n.position, evt.position);
            });

            if (index < 0) {
                if (evt.value.trim() !== '') {
                    nodes.push({ id: __WEBPACK_IMPORTED_MODULE_2__helper__["f" /* getId */](), position: evt.position, value: evt.value });
                }
            } else {
                var id = nodes[index].id;

                nodes[index] = { id: id, position: [].concat(_toConsumableArray(evt.position)), value: evt.value };

                if (evt.value.trim() === '') {
                    // Cleanup if necessary

                    var existingEdge = _this.props.data.edges.find(function (e) {
                        return e.from === id || e.to === id;
                    });
                    if (!existingEdge) nodes[index] = null;
                }
            }

            onDataChange({
                data: {
                    nodes: nodes.filter(function (x) {
                        return x != null;
                    }),
                    edges: _this.props.data.edges
                }
            });
        };

        _this.handleEdgeClick = function (index) {
            if (_this.edgeClickHandlersCache == null) _this.edgeClickHandlersCache = {};

            if (_this.edgeClickHandlersCache[index] == null) {
                _this.edgeClickHandlersCache[index] = function (evt) {
                    var _this$props$onEdgeCli = _this.props.onEdgeClick,
                        onEdgeClick = _this$props$onEdgeCli === undefined ? function () {} : _this$props$onEdgeCli;


                    evt.edge = index;
                    onEdgeClick(evt);
                };
            }

            return _this.edgeClickHandlersCache[index];
        };

        _this.state = {
            width: null,
            height: null,
            cameraPosition: Array(2).fill(Math.round(-props.cellSize / 2)),
            editPosition: [null, null],
            phantomEdge: null
        };
        return _this;
    }

    _createClass(Grid, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.updateSize();

            window.addEventListener('resize', function () {
                return _this2.updateSize();
            });

            document.addEventListener('mouseup', function () {
                _this2.mouseDown = null;

                var phantomEdge = _this2.state.phantomEdge;


                if (phantomEdge != null) {
                    if (!__WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](phantomEdge.from, phantomEdge.to)) {
                        // Add edge

                        var newNodes = [].concat(_toConsumableArray(_this2.props.data.nodes));

                        var _map = [phantomEdge.from, phantomEdge.to].map(function (position) {
                            return newNodes.find(function (n) {
                                return __WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](n.position, position);
                            });
                        }),
                            _map2 = _slicedToArray(_map, 2),
                            fromNode = _map2[0],
                            toNode = _map2[1];

                        if (fromNode == null) newNodes.push(fromNode = { id: __WEBPACK_IMPORTED_MODULE_2__helper__["f" /* getId */](), position: phantomEdge.from, value: '' });
                        if (toNode == null) newNodes.push(toNode = { id: __WEBPACK_IMPORTED_MODULE_2__helper__["f" /* getId */](), position: phantomEdge.to, value: '' });

                        var newEdges = [].concat(_toConsumableArray(_this2.props.data.edges), [{
                            from: fromNode.id,
                            to: toNode.id
                        }]);

                        var _props$onDataChange = _this2.props.onDataChange,
                            onDataChange = _props$onDataChange === undefined ? function () {} : _props$onDataChange;

                        onDataChange({ data: { nodes: newNodes, edges: newEdges } });
                    }

                    _this2.setState({ phantomEdge: null });
                }
            });

            document.addEventListener('keyup', function (evt) {
                if (evt.keyCode === 27) {
                    // Escape

                    evt.stopPropagation();
                    _this2.setState({ editPosition: [null, null] });
                }
            });

            document.addEventListener('mousemove', function (evt) {
                if (_this2.mouseDown == null) return;

                evt.preventDefault();

                var cellSize = _this2.props.cellSize;
                var cameraPosition = _this2.state.cameraPosition;

                var newPosition = [evt.clientX, evt.clientY].map(function (x, i) {
                    return Math.floor((x + cameraPosition[i]) / cellSize);
                });

                if (_this2.mouseDown.mode === 'pan') {
                    var movementX = evt.movementX,
                        movementY = evt.movementY;


                    _this2.setState({
                        cameraPosition: __WEBPACK_IMPORTED_MODULE_2__helper__["d" /* arrSubtract */](cameraPosition, [movementX, movementY])
                    });
                } else if (_this2.mouseDown.mode === 'move') {
                    var nodeIndex = _this2.mouseDown.nodeIndex;

                    if (nodeIndex < 0) return;

                    var existingNode = _this2.props.data.nodes.find(function (n) {
                        return __WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](n.position, newPosition);
                    });
                    if (existingNode != null) return;

                    var _props$onDataChange2 = _this2.props.onDataChange,
                        onDataChange = _props$onDataChange2 === undefined ? function () {} : _props$onDataChange2;


                    onDataChange({
                        data: {
                            nodes: _this2.props.data.nodes.map(function (x, i) {
                                return i !== nodeIndex ? x : _extends({}, x, { position: newPosition });
                            }),

                            edges: _this2.props.data.edges
                        }
                    });
                } else if (_this2.mouseDown.mode === 'arrow') {
                    var from = _this2.mouseDown.position;

                    var to = newPosition;

                    if (_this2.state.phantomEdge != null && __WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](from, _this2.state.phantomEdge.from) && __WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](to, _this2.state.phantomEdge.to)) return;

                    _this2.setState({
                        phantomEdge: { from: from, to: to }
                    });
                }
            });
        }
    }, {
        key: 'updateSize',
        value: function updateSize() {
            var _element$getBoundingC = this.element.getBoundingClientRect(),
                width = _element$getBoundingC.width,
                height = _element$getBoundingC.height;

            this.setState({ width: width, height: height });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.state.width == null) return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('section', { ref: function ref(el) {
                    return _this3.element = el;
                }, id: 'grid' });

            var cellSize = this.props.cellSize;

            var size = [this.state.width, this.state.height];

            var _state$cameraPosition = this.state.cameraPosition.map(function (x) {
                return Math.floor(x / cellSize);
            }),
                _state$cameraPosition2 = _slicedToArray(_state$cameraPosition, 2),
                xstart = _state$cameraPosition2[0],
                ystart = _state$cameraPosition2[1];

            var _state$cameraPosition3 = this.state.cameraPosition.map(function (x, i) {
                return Math.floor((x + size[i]) / cellSize);
            }),
                _state$cameraPosition4 = _slicedToArray(_state$cameraPosition3, 2),
                xend = _state$cameraPosition4[0],
                yend = _state$cameraPosition4[1];

            var cols = xend - xstart + 1,
                rows = yend - ystart + 1;

            var _helper$arrSubtract = __WEBPACK_IMPORTED_MODULE_2__helper__["d" /* arrSubtract */](__WEBPACK_IMPORTED_MODULE_2__helper__["c" /* arrScale */](cellSize, [xstart, ystart]), this.state.cameraPosition),
                _helper$arrSubtract2 = _slicedToArray(_helper$arrSubtract, 2),
                tx = _helper$arrSubtract2[0],
                ty = _helper$arrSubtract2[1];

            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'section',
                {
                    ref: function ref(el) {
                        return _this3.element = el;
                    },
                    id: 'grid',
                    'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({}, this.props.mode, true))
                },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'ol',
                    {
                        style: {
                            gridTemplateColumns: 'repeat(' + cols + ', ' + cellSize + 'px)',
                            gridTemplateRows: 'repeat(' + rows + ', ' + cellSize + 'px)',
                            left: tx,
                            top: ty,
                            width: cols * cellSize,
                            height: rows * cellSize
                        },

                        onMouseDown: this.handleNodeMouseDown,
                        onMouseUp: this.handleNodeMouseUp
                    },
                    Array(rows).fill().map(function (_, j) {
                        return Array(cols).fill().map(function (_, i) {
                            return function (position) {
                                return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__GridCell__["a" /* default */], {
                                    key: position.join(','),
                                    position: position,
                                    size: cellSize,
                                    edit: __WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](position, _this3.state.editPosition),
                                    value: function (node) {
                                        return node && node.value;
                                    }(_this3.props.data.nodes.find(function (n) {
                                        return __WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](n.position, position);
                                    })),

                                    onGrabberMouseDown: _this3.handleNodeGrabberMouseDown,
                                    onSubmit: _this3.handleNodeSubmit,
                                    onChange: _this3.handleNodeChange
                                });
                            }([i + xstart, j + ystart]);
                        });
                    })
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'ul',
                    {
                        style: {
                            left: -this.state.cameraPosition[0],
                            top: -this.state.cameraPosition[1]
                        }
                    },
                    this.props.data.edges.map(function (edge, i) {
                        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__GridEdge__["a" /* default */], {
                            cellSize: cellSize,

                            id: i.toString(),
                            from: _this3.props.data.nodes.find(function (n) {
                                return n.id === edge.from;
                            }).position,
                            to: _this3.props.data.nodes.find(function (n) {
                                return n.id === edge.to;
                            }).position,
                            selected: _this3.props.selectedEdge === i,

                            bend: edge.bend,
                            tail: edge.tail,
                            line: edge.line,
                            head: edge.head,
                            value: edge.value,
                            labelPosition: edge.labelPosition,

                            onClick: _this3.handleEdgeClick(i)
                        });
                    }),
                    this.state.phantomEdge && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_4__GridEdge__["a" /* default */], {
                        cellSize: cellSize,
                        phantom: true,

                        from: this.state.phantomEdge.from,
                        to: this.state.phantomEdge.to
                    })
                )
            );
        }
    }]);

    return Grid;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var GridCell = function (_Component) {
    _inherits(GridCell, _Component);

    function GridCell() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, GridCell);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GridCell.__proto__ || Object.getPrototypeOf(GridCell)).call.apply(_ref, [this].concat(args))), _this), _this.handleGrabberMouseDown = function (evt) {
            var _this$props$onGrabber = _this.props.onGrabberMouseDown,
                onGrabberMouseDown = _this$props$onGrabber === undefined ? function () {} : _this$props$onGrabber;


            evt.position = _this.props.position;

            onGrabberMouseDown(evt);
        }, _this.handleGrabberDragStart = function (evt) {
            evt.preventDefault();
        }, _this.handleEditSubmit = function (evt) {
            evt.preventDefault();

            var _this$props$onSubmit = _this.props.onSubmit,
                onSubmit = _this$props$onSubmit === undefined ? function () {} : _this$props$onSubmit;

            onSubmit(evt);
        }, _this.handleInputBlur = function (evt) {
            _this.handleEditSubmit(evt);
        }, _this.stopPropagation = function (evt) {
            evt.stopPropagation();
        }, _this.handleInputChange = function (evt) {
            var _this$props$onChange = _this.props.onChange,
                onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;


            onChange({
                position: _this.props.position,
                value: evt.currentTarget.value
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(GridCell, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.componentDidUpdate();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return nextProps.value !== this.props.value || nextProps.edit !== this.props.edit;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.valueElement.querySelectorAll(['span[id^="MathJax"]', '.MathJax_Preview', 'script'].join(', '))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var el = _step.value;

                    el.remove();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.props.value) {
                MathJax.Hub.Queue(['Typeset', MathJax.Hub, this.valueElement]);
            }

            if (this.inputElement != null && prevProps.edit !== this.props.edit) {
                this.inputElement.select();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                {
                    'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('grid-cell', { edit: this.props.edit }),
                    'data-position': this.props.position.join(',')
                },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
                    'class': 'grabber',
                    src: './img/grabber.svg',

                    onMouseDown: this.handleGrabberMouseDown,
                    onDragStart: this.handleGrabberDragStart
                }),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'div',
                    { 'class': 'value', ref: function ref(el) {
                            return _this2.valueElement = el;
                        } },
                    this.props.value ? '\\(' + this.props.value + '\\)' : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'span',
                        { 'class': 'hide' },
                        '_'
                    )
                ),
                this.props.edit && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'form',
                    { 'class': 'edit', onSubmit: this.handleEditSubmit },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
                        ref: function ref(el) {
                            return _this2.inputElement = el;
                        },
                        type: 'text',
                        value: this.props.value,

                        onBlur: this.handleInputBlur,
                        onInput: this.handleInputChange,
                        onMouseDown: this.stopPropagation,
                        onKeyDown: this.stopPropagation
                    })
                )
            );
        }
    }]);

    return GridCell;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (GridCell);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__geometry__ = __webpack_require__(16);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var GridEdge = function (_Component) {
    _inherits(GridEdge, _Component);

    function GridEdge(props) {
        _classCallCheck(this, GridEdge);

        var _this = _possibleConstructorReturn(this, (GridEdge.__proto__ || Object.getPrototypeOf(GridEdge)).call(this));

        _this.state = {
            labelX: '50%',
            labelY: 0,
            startPoint: props.from.map(function (x) {
                return x * props.cellSize + props.cellSize / 2;
            }),
            endPoint: props.to.map(function (x) {
                return x * props.cellSize + props.cellSize / 2;
            })
        };
        return _this;
    }

    _createClass(GridEdge, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.componentDidUpdate();
            this.componentWillReceiveProps();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            for (var key in nextProps) {
                if (nextProps[key] !== this.props[key]) return true;
            }

            for (var _key in nextState) {
                if (nextState[_key] instanceof Array && !__WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](nextState[_key], this.state[_key]) || !(nextState[_key] instanceof Array) && nextState[_key] !== this.state[_key]) return true;
            }

            return false;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps != null && nextProps.from === this.props.from && nextProps.to === this.props.to && nextProps.bend === this.props.bend) return;

            if (nextProps == null) nextProps = this.props;

            MathJax.Hub.Queue(function () {
                var _nextProps = nextProps,
                    cellSize = _nextProps.cellSize;

                var query = function query(position) {
                    return '.grid-cell[data-position="' + position.join(',') + '"] .value';
                };

                var fromLatexElement = document.querySelector(query(nextProps.from));
                var toLatexElement = document.querySelector(query(nextProps.to));

                var fromWidth = 0,
                    fromHeight = 0,
                    toWidth = 0,
                    toHeight = 0;


                if (fromLatexElement != null) {
                    var _fromLatexElement$get = fromLatexElement.getBoundingClientRect(),
                        width = _fromLatexElement$get.width,
                        height = _fromLatexElement$get.height;

                    fromWidth = width;
                    fromHeight = height;
                }

                if (toLatexElement != null) {
                    var _toLatexElement$getBo = toLatexElement.getBoundingClientRect(),
                        _width = _toLatexElement$getBo.width,
                        _height = _toLatexElement$getBo.height;

                    toWidth = _width;
                    toHeight = _height;
                }

                ;
                var _map = [toWidth, toHeight].map(function (x) {
                    return Math.min(cellSize, x + 20);
                });

                var _map2 = _slicedToArray(_map, 2);

                toWidth = _map2[0];
                toHeight = _map2[1];

                var _map3 = [fromWidth, fromHeight].map(function (x) {
                    return Math.min(cellSize, x + 40);
                });

                var _map4 = _slicedToArray(_map3, 2);

                fromWidth = _map4[0];
                fromHeight = _map4[1];

                var _map5 = [nextProps.from, nextProps.to].map(function (x) {
                    return x.map(function (y) {
                        return y * cellSize + cellSize / 2;
                    });
                }),
                    _map6 = _slicedToArray(_map5, 2),
                    fromCenter = _map6[0],
                    toCenter = _map6[1];

                var m = __WEBPACK_IMPORTED_MODULE_2__helper__["c" /* arrScale */](0.5, __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* arrAdd */](fromCenter, toCenter));
                var d = __WEBPACK_IMPORTED_MODULE_2__helper__["d" /* arrSubtract */](toCenter, fromCenter);

                var _getLengthAngle = _this2.getLengthAngle(),
                    length = _getLengthAngle.length;

                var controlPoint = __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* arrAdd */](m, __WEBPACK_IMPORTED_MODULE_2__helper__["c" /* arrScale */](length * Math.tan(-(nextProps.bend || 0) * Math.PI / 180) / 2, __WEBPACK_IMPORTED_MODULE_3__geometry__["e" /* normalize */](__WEBPACK_IMPORTED_MODULE_3__geometry__["a" /* getPerpendicularLeftVector */](d))));

                var fromRect = __WEBPACK_IMPORTED_MODULE_3__geometry__["b" /* getRectCenteredAround */](fromCenter, fromWidth, fromHeight);
                var toRect = __WEBPACK_IMPORTED_MODULE_3__geometry__["b" /* getRectCenteredAround */](toCenter, toWidth, toHeight);
                var fromIntersection = __WEBPACK_IMPORTED_MODULE_3__geometry__["c" /* getRectSegmentIntersections */](fromRect, fromCenter, controlPoint)[0];
                var toIntersection = __WEBPACK_IMPORTED_MODULE_3__geometry__["c" /* getRectSegmentIntersections */](toRect, controlPoint, toCenter)[0];

                _this2.setState({
                    startPoint: fromIntersection || fromCenter,
                    endPoint: toIntersection || toCenter
                });
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this3 = this;

            if (this.valueElement == null) return;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.valueElement.querySelectorAll(['span[id^="MathJax"]', '.MathJax_Preview', 'script'].join(', '))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var el = _step.value;

                    el.remove();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.props.value) {
                MathJax.Hub.Queue(['Typeset', MathJax.Hub, this.valueElement]);
            }

            MathJax.Hub.Queue(function () {
                if (prevProps != null && _this3.props.value === prevProps.value && _this3.props.labelPosition === prevProps.labelPosition && _this3.props.from === prevProps.from && _this3.props.to === prevProps.to && _this3.props.bend === prevProps.bend && _this3.state.startPoint === prevState.startPoint && _this3.state.endPoint === prevState.endPoint) return;

                if (prevProps == null) prevProps = _this3.props;

                var bbox = _this3.edgePath.getBBox();

                var _window$getComputedSt = window.getComputedStyle(_this3.valueElement),
                    width = _window$getComputedSt.width,
                    height = _window$getComputedSt.height;

                var _map7 = [width, height].map(parseFloat);

                var _map8 = _slicedToArray(_map7, 2);

                width = _map8[0];
                height = _map8[1];

                var _getLengthAngle2 = _this3.getLengthAngle(),
                    angle = _getLengthAngle2.angle;

                var newHeight = height * Math.abs(Math.cos(angle)) + width * Math.abs(Math.sin(angle));
                var heightDiff = newHeight - height;

                _this3.setState({
                    labelX: 'calc(50% + ' + (-width / 2 - 6.5) + 'px)',
                    labelY: {
                        left: bbox.y - height - heightDiff / 2 - 5,
                        right: bbox.y + bbox.height + heightDiff / 2 + 5,
                        inside: _this3.props.bend > 0 ? bbox.y - height / 2 : bbox.y + bbox.height - height / 2
                    }[_this3.props.labelPosition || 'left']
                });
            });
        }
    }, {
        key: 'getLengthAngle',
        value: function getLengthAngle() {
            var _state = this.state,
                startPoint = _state.startPoint,
                endPoint = _state.endPoint;

            var _helper$arrSubtract = __WEBPACK_IMPORTED_MODULE_2__helper__["d" /* arrSubtract */](endPoint, startPoint),
                _helper$arrSubtract2 = _slicedToArray(_helper$arrSubtract, 2),
                dx = _helper$arrSubtract2[0],
                dy = _helper$arrSubtract2[1];

            return {
                length: __WEBPACK_IMPORTED_MODULE_3__geometry__["d" /* norm */]([dx, dy]),
                angle: Math.atan2(dy, dx)
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            if (__WEBPACK_IMPORTED_MODULE_2__helper__["b" /* arrEquals */](this.props.from, this.props.to)) return;

            var _state2 = this.state,
                startPoint = _state2.startPoint,
                endPoint = _state2.endPoint;

            var _helper$arrScale = __WEBPACK_IMPORTED_MODULE_2__helper__["c" /* arrScale */](0.5, __WEBPACK_IMPORTED_MODULE_2__helper__["a" /* arrAdd */](startPoint, endPoint)),
                _helper$arrScale2 = _slicedToArray(_helper$arrScale, 2),
                mx = _helper$arrScale2[0],
                my = _helper$arrScale2[1];

            var _getLengthAngle3 = this.getLengthAngle(),
                length = _getLengthAngle3.length,
                angle = _getLengthAngle3.angle;

            var degree = angle * 180 / Math.PI;

            var bend = this.props.bend || 0;
            var cx = length / 2,
                cy = length * Math.tan(bend * Math.PI / 180) / 2;

            var height = Math.max(Math.abs(cy) + 13, 13);
            var path = 'M 9.764 ' + height / 2 + ' Q ' + (9.764 + cx) + ' ' + (height / 2 - cy) + ' ' + length + ' ' + height / 2;

            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'li',
                {
                    'data-id': this.props.id,
                    'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('grid-edge', {
                        selected: this.props.selected,
                        phantom: this.props.phantom
                    }),
                    style: {
                        height: height,
                        width: length + 13,
                        left: mx - (length + 13) / 2,
                        top: my - height / 2,
                        transform: 'rotate(' + degree + 'deg)'
                    },

                    onClick: this.props.onClick
                },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'svg',
                    {
                        ref: function ref(el) {
                            return _this4.svgElement = el;
                        },
                        width: length + 13,
                        height: height
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
                        'class': 'mouse',
                        fill: 'none',
                        'stroke-width': '12',
                        stroke: 'transparent',
                        'stroke-linecap': 'square',
                        d: path
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', {
                        ref: function ref(el) {
                            return _this4.edgePath = el;
                        },
                        fill: 'none',
                        'stroke-width': this.props.line == 'double' ? "3" : "1",
                        stroke: this.props.line == 'double' ? "red" : "black",
                        'stroke-dasharray': {
                            double: null,
                            solid: null,
                            dashed: '7, 3',
                            dotted: '2, 4'
                        }[this.props.line],
                        d: path
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('image', {
                        x: '0', y: height / 2 - 13 / 2,
                        width: '9.764', height: '13',
                        transform: 'rotate(' + -bend + ' ' + 9.764 + ' ' + height / 2 + ')',
                        xlinkHref: './img/arrow/' + (this.props.tail || 'none') + '.svg'
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('image', {
                        x: length - 9.764, y: height / 2 - 13 / 2,
                        width: '9.764', height: '13',
                        transform: 'rotate(' + bend + ' ' + length + ' ' + height / 2 + ')',
                        xlinkHref: './img/arrow/' + (this.props.head || 'default') + '.svg'
                    })
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'div',
                    {
                        ref: function ref(el) {
                            return _this4.valueElement = el;
                        },
                        'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('value', this.props.labelPosition),
                        style: {
                            left: this.state.labelX,
                            top: this.state.labelY,
                            transform: 'rotate(' + -degree + 'deg)'
                        }
                    },
                    this.props.value ? '\\(' + this.props.value + '\\)' : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'span',
                        { 'class': 'hide' },
                        '_'
                    )
                )
            );
        }
    }]);

    return GridEdge;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (GridEdge);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getRectCenteredAround;
/* unused harmony export insideRect */
/* harmony export (immutable) */ __webpack_exports__["c"] = getRectSegmentIntersections;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPerpendicularLeftVector;
/* harmony export (immutable) */ __webpack_exports__["d"] = norm;
/* harmony export (immutable) */ __webpack_exports__["e"] = normalize;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getRectCenteredAround(_ref, width, height) {
    var _ref2 = _slicedToArray(_ref, 2),
        x = _ref2[0],
        y = _ref2[1];

    return {
        width: width,
        height: height,
        left: x - width / 2,
        top: y - height / 2
    };
}

function insideRect(rect, p) {
    var left = rect.left,
        top = rect.top,
        width = rect.width,
        height = rect.height;

    var _p = _slicedToArray(p, 2),
        p1 = _p[0],
        p2 = _p[1];

    return left <= p1 && p1 <= left + width && top <= p2 && p2 <= top + height;
}

function getRectSegmentIntersections(rect, p1, p2) {
    var left = rect.left,
        top = rect.top,
        width = rect.width,
        height = rect.height;

    var _p2 = _slicedToArray(p1, 2),
        x1 = _p2[0],
        y1 = _p2[1];

    var _p3 = _slicedToArray(p2, 2),
        x2 = _p3[0],
        y2 = _p3[1];

    var d = [x2 - x1, y2 - y1];
    var leftTop = [left, top];

    var ts = [x1, y1].map(function (x, i) {
        return [leftTop[i], leftTop[i] + [width, height][i]].map(function (y) {
            return (y - x) / d[i];
        });
    }).reduce(function (acc, x) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(x));
    }, []);

    return ts.filter(function (t) {
        return 0 <= t && t <= 1;
    }).map(function (t) {
        return p1.map(function (x, i) {
            return x + t * d[i];
        });
    }).filter(function (p) {
        return insideRect(rect, p);
    });
}

function getPerpendicularLeftVector(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        x = _ref4[0],
        y = _ref4[1];

    return [-y, x];
}

function norm(p) {
    return Math.sqrt(p.reduce(function (acc, x) {
        return acc + x * x;
    }, 0));
}

function normalize(p) {
    var n = norm(p);
    return p.map(function (x) {
        return x / n;
    });
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Toolbox__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Properties = function (_Component) {
    _inherits(Properties, _Component);

    function Properties() {
        _classCallCheck(this, Properties);

        var _this = _possibleConstructorReturn(this, (Properties.__proto__ || Object.getPrototypeOf(Properties)).call(this));

        _this.handleButtonClick = function (id) {
            if (_this.buttonClickHandlersCache == null) _this.buttonClickHandlersCache = {};

            if (_this.buttonClickHandlersCache[id] == null) {
                _this.buttonClickHandlersCache[id] = function (evt) {
                    var _this$props = _this.props,
                        data = _this$props.data,
                        _this$props$onChange = _this$props.onChange,
                        onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;

                    var change = {};

                    if (['tail', 'mapsto', 'twoheads'].includes(id)) {
                        var prop = id === 'twoheads' ? 'head' : 'tail';

                        change = _defineProperty({}, prop, data[prop] === id ? 'none' : id);
                    } else if (id === 'head') {
                        change = { head: data.head == null ? 'none' : null };
                    } else if (['solid', 'dashed', 'dotted', 'double'].includes(id)) {
                        change = { line: id };
                    } else if (['labelleft', 'labelright', 'labelinside'].includes(id)) {
                        change = { labelPosition: id.slice(5) };
                    } else if (['hook', 'harpoon'].includes(id)) {
                        var _prop = id === 'hook' ? 'tail' : 'head';
                        var ids = [id, id + 'alt', 'none'];
                        var index = (ids.indexOf(data[_prop]) + 1) % ids.length;

                        change = _defineProperty({}, _prop, ids[index]);
                    } else if (['bendleft', 'bendright'].includes(id)) {
                        var _data$bend = data.bend,
                            bend = _data$bend === undefined ? 0 : _data$bend;

                        var increase = bend === 0 || (id === 'bendleft' ? bend > 0 : bend < 0);
                        var sign = bend !== 0 ? Math.sign(bend) : id === 'bendleft' ? 1 : -1;
                        var steps = [0, 30, 49, 60, 67, 71, 74, 76, 78, 79, 80];
                        var _index = steps.reduce(function (acc, x, i) {
                            return x <= Math.abs(bend) ? i : acc;
                        }, -1);
                        if (_index < steps.length - 1 && bend >= (steps[_index + 1] + steps[_index]) / 2) _index++;

                        var newBend = sign * steps[Math.min(_index + (+increase * 2 - 1), steps.length - 1)];

                        change = { bend: __WEBPACK_IMPORTED_MODULE_2__helper__["e" /* clamp */](-80, 80, newBend) };
                    } else if (['reversearrow'].includes(id)) {
                        var from = data.from,
                            to = data.to,
                            _data$labelPosition = data.labelPosition,
                            labelPosition = _data$labelPosition === undefined ? 'left' : _data$labelPosition;


                        change = { to: from, from: to

                            // Invert label position

                        };var newLabelPos = labelPosition;

                        if (labelPosition === 'left') {
                            newLabelPos = 'right';
                        } else if (labelPosition === 'right') {
                            newLabelPos = 'left';
                        }

                        change.labelPosition = newLabelPos;

                        // Invert bend

                        if (data.bend != null) {
                            change.bend = -data.bend;
                        }
                    }

                    onChange({ data: _extends({}, data, change) });
                };
            }

            return _this.buttonClickHandlersCache[id];
        };

        _this.handleEditButtonClick = function () {
            _this.updateEditPosition();
            _this.setState({ edit: true });
        };

        _this.handleFormSubmit = function (evt) {
            console.log(evt.keyCode);
            evt.preventDefault();
            _this.setState({ edit: false });
        };

        _this.handleInputBlur = function () {
            _this.setState({ edit: false });
        };

        _this.handleInputChange = function (evt) {
            var value = evt.currentTarget.value;
            var _this$props$onChange2 = _this.props.onChange,
                onChange = _this$props$onChange2 === undefined ? function () {} : _this$props$onChange2;


            onChange({ data: _extends({}, _this.props.data, { value: value }) });
        };

        _this.handleInputKeyDown = function (evt) {
            evt.stopPropagation();
        };

        _this.handleInputKeyUp = function (evt) {
            if (evt.keyCode === 27) {
                // Escape

                evt.stopPropagation();
                _this.setState({ edit: false });
            }
        };

        _this.state = {
            edit: false,
            editTop: 0,
            editLeft: 0
        };
        return _this;
    }

    _createClass(Properties, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var edgeControl = {
                38: 'bendleft', // Up arrow
                40: 'bendright', // Down arrow
                82: 'reversearrow', // R
                65: 'labelleft', // A
                83: 'labelinside', // S
                68: 'labelright' // D
            };

            var edgeEdit = 13; // Enter
            var edgeDelete = [46, 8]; // Delete, Backspace

            document.addEventListener('keydown', function (evt) {
                if (!_this2.props.show || _this2.state.edit) return;

                if (edgeControl[evt.keyCode] != null) {
                    evt.preventDefault();

                    _this2.handleButtonClick(edgeControl[evt.keyCode])();
                } else if (edgeDelete.includes(evt.keyCode)) {
                    evt.preventDefault();

                    var _props$onRemoveClick = _this2.props.onRemoveClick,
                        onRemoveClick = _props$onRemoveClick === undefined ? function () {} : _props$onRemoveClick;

                    onRemoveClick(evt);
                } else if (evt.keyCode == edgeEdit) {
                    evt.preventDefault();

                    _this2.handleEditButtonClick();
                }
            });
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextProps.show !== this.props.show || nextProps.data !== this.props.data || nextState.edit !== this.state.edit || nextState.editTop !== this.state.editTop || nextState.editLeft !== this.state.editLeft;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_, prevState) {
            if (!prevState.edit && this.state.edit) {
                this.inputElement.select();
            } else if (prevState.edit && !this.state.edit) {
                this.inputElement.blur();
            }
        }
    }, {
        key: 'updateEditPosition',
        value: function updateEditPosition() {
            var valueElement = document.querySelector('.grid-edge[data-id="' + this.props.edgeId + '"] .value');

            var _valueElement$getBoun = valueElement.getBoundingClientRect(),
                left = _valueElement$getBoun.left,
                top = _valueElement$getBoun.top,
                width = _valueElement$getBoun.width;

            var _window$getComputedSt = window.getComputedStyle(this.editElement),
                editWidth = _window$getComputedSt.width,
                editHeight = _window$getComputedSt.height;

            this.setState({
                editLeft: left + width / 2 - parseFloat(editWidth) / 2,
                editTop: top - parseFloat(editHeight) - 10
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var data = this.props.data == null ? {} : this.props.data;

            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'section',
                {
                    id: 'properties',
                    'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
                        show: this.props.show,
                        edit: this.state.edit
                    })
                },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_3__Toolbox__["c" /* default */],
                    null,
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: false,
                        icon: './img/properties/reverse.svg',
                        name: 'Reverse Arrow (R)',
                        onClick: this.handleButtonClick('reversearrow')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["b" /* Separator */], null),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: data.tail === 'tail',
                        icon: './img/properties/tail.svg',
                        name: 'Tail',
                        onClick: this.handleButtonClick('tail')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: data.tail === 'mapsto',
                        icon: './img/properties/mapsto.svg',
                        name: 'Maps To',
                        onClick: this.handleButtonClick('mapsto')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: ['hook', 'hookalt'].includes(data.tail),
                        icon: './img/properties/' + (data.tail === 'hookalt' ? 'hookalt' : 'hook') + '.svg',
                        name: 'Hook',
                        onClick: this.handleButtonClick('hook')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["b" /* Separator */], null),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        icon: './img/properties/bendright.svg',
                        name: 'Bend Right (Arrow Key Down)',
                        onClick: this.handleButtonClick('bendright')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        icon: './img/properties/bendleft.svg',
                        name: 'Bend Left (Arrow Key Up)',
                        onClick: this.handleButtonClick('bendleft')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["b" /* Separator */], null),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: data.line === 'dotted',
                        icon: './img/properties/dotted.svg',
                        name: 'Dotted',
                        onClick: this.handleButtonClick('dotted')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: data.line === 'dashed',
                        icon: './img/properties/dashed.svg',
                        name: 'Dashed',
                        onClick: this.handleButtonClick('dashed')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: !data.line === 'double',
                        icon: './img/properties/double.svg',
                        name: 'Double',
                        onClick: this.handleButtonClick('double')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: !data.line || data.line === 'solid',
                        icon: './img/properties/solid.svg',
                        name: 'Solid',
                        onClick: this.handleButtonClick('solid')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["b" /* Separator */], null),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: ['harpoon', 'harpoonalt'].includes(data.head),
                        icon: './img/properties/' + (data.head === 'harpoonalt' ? 'harpoonalt' : 'harpoon') + '.svg',
                        name: 'Harpoon',
                        onClick: this.handleButtonClick('harpoon')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: data.head == null,
                        icon: './img/properties/head.svg',
                        name: 'Default Head',
                        onClick: this.handleButtonClick('head')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: data.head == 'twoheads',
                        icon: './img/properties/twoheads.svg',
                        name: 'Two Heads',
                        onClick: this.handleButtonClick('twoheads')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["b" /* Separator */], null),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: !data.labelPosition || data.labelPosition === 'left',
                        icon: './img/properties/labelleft.svg',
                        name: 'Left Label (A)',
                        onClick: this.handleButtonClick('labelleft')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: data.labelPosition === 'inside',
                        icon: './img/properties/labelinside.svg',
                        name: 'Inside Label (S)',
                        onClick: this.handleButtonClick('labelinside')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: data.labelPosition === 'right',
                        icon: './img/properties/labelright.svg',
                        name: 'Right Label (D)',
                        onClick: this.handleButtonClick('labelright')
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        checked: this.state.edit,
                        icon: './img/properties/edit.svg',
                        name: 'Edit Label (Enter)',
                        onClick: this.handleEditButtonClick
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["b" /* Separator */], null),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__Toolbox__["a" /* Button */], {
                        'class': 'remove',
                        icon: './img/properties/trash.svg',
                        name: 'Remove Arrow (Del)',
                        onClick: this.props.onRemoveClick
                    })
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'form',
                    {
                        ref: function ref(el) {
                            return _this3.editElement = el;
                        },
                        'class': 'edit',
                        style: {
                            left: this.state.editLeft,
                            top: this.state.editTop
                        },
                        onSubmit: this.handleFormSubmit
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', {
                        ref: function ref(el) {
                            return _this3.inputElement = el;
                        },
                        type: 'text',
                        value: data.value,

                        onBlur: this.handleInputBlur,
                        onInput: this.handleInputChange,
                        onKeyDown: this.handleInputKeyDown,
                        onKeyUp: this.handleInputKeyUp
                    })
                )
            );
        }
    }]);

    return Properties;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Properties);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js